import React from 'react';

interface SearchableDropdownProps {
  options: { value: string; label: string }[];
  value?: string;
  onSelect: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

export const SearchableDropdown: React.FC<SearchableDropdownProps> = ({ 
  options, 
  value,
  onSelect, 
  placeholder = "Select...",
  className = "",
  disabled = false
}) => {
  return (
    <select 
      className={`border border-gray-300 rounded-lg p-2 w-full focus:ring-2 focus:ring-primary focus:border-transparent ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${className}`}
      value={value || ""}
      onChange={(e) => onSelect(e.target.value)}
      disabled={disabled}
      title={placeholder}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};
